<ng-progress color="red" [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'" (started)="ngProgress.startedClass" (completed)="ngProgress.endedClass"></ng-progress>

<div style="margin-left: 1px;" *ngIf="showEndUserTab" id="enduser" class="subBlockContainer">
    <div class="subBlockContent">
        <child-header [title]="title" (closeEvent)="close()"></child-header>
        <div *ngIf="loadContent" class="child-body">
            <div class="inner-subBlock-wrapper">
                <!-- <div class="page-title-wrapper">
          <div class="title blade-title-font">
            {{title}}
          </div>
          <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
        </div> -->
                <div class="collect-order" *ngIf="!shippingAddressModel?.collectTheOrder">
                    <div class="checkbox-center" *ngIf="checkoutViewModel && showCopyFromShippingDetails">
                        <mat-slide-toggle (change)="switchShipInfo($event)">
                            <span>Copy from shipping information</span>
                        </mat-slide-toggle>
                    </div>
                </div>
                <div class="top-divider" *ngIf="!shippingAddressModel?.collectTheOrder"></div>
                <div class="enduser-title-content">
                    <a id="shipaddressdropdown" (click)="openSelectEndUserPage()">Select End User</a>
                </div>
                <br />
                <div (click)="clearAllFields();"><span class="clearFilterButton">Clear All Fields</span></div>
                <br />
                <div [formGroup]="addressFormGroup">
                    <div id="endUserDetail">
                        <div class="address-form">

                            <ng-container *ngIf="companyNameBool;else noshowcompanyname">
                                <mat-form-field [floatLabel]="'always'">
                                    <input matInput class="companyNameValidate" formControlName="out_company_name" placeholder="Company Name" [required]="companyNameBool">
                                </mat-form-field>                                
                            </ng-container>
                            <ng-template #noshowcompanyname>
                                <ng-container *ngIf="companyNameN;else optionalcompanyname">                                  
                                        <input matInput class="companyNameValidate" formControlName="out_company_name" placeholder="Company Name" style = "display: none">                                
                                    </ng-container>                                                         
                            </ng-template>
                            <ng-template #optionalcompanyname>                               
                                <mat-form-field [floatLabel]="'always'">
                                    <input matInput class="companyNameValidate" formControlName="out_company_name" placeholder="Company Name">
                                </mat-form-field>                                 
                            </ng-template>                                                       

                            <ng-container *ngIf="addressBool;else noshowaddress">
                                <mat-form-field [floatLabel]="'always'">
                                    <input matInput id = "addressLine1" class="addressLine1Validate" formControlName="out_address_1" (change)="omit_nonprintable_char($event)" placeholder="Address Line 1" [required]="addressBool">
                                </mat-form-field>

                                <mat-form-field [floatLabel]="'always'">
                                    <input matInput id = "addressLine2" class="addressLine2Validate" formControlName="out_address_2" (change)="omit_nonprintable_char($event)" placeholder="Address Line 2">
                                </mat-form-field>

                                <mat-form-field [floatLabel]="'always'">
                                    <input matInput id = "addressLine3" class="addressLine3Validate" formControlName="out_address_3" (change)="omit_nonprintable_char($event)" placeholder="Addiress Line 3">
                                </mat-form-field>
                            </ng-container>    
                            <ng-template #noshowaddress>
                                <ng-container *ngIf="addressN;else optionaladdress">                                  
                                    <input matInput id = "addressLine1" class="addressLine1Validate" formControlName="out_address_1" (change)="omit_nonprintable_char($event)" placeholder="Address Line 1" style = "display: none">
                                    <input matInput id = "addressLine2" class="addressLine2Validate" formControlName="out_address_2" (change)="omit_nonprintable_char($event)" placeholder="Address Line 2" style = "display: none">
                                    <input matInput id = "addressLine3" class="addressLine3Validate" formControlName="out_address_3" (change)="omit_nonprintable_char($event)" placeholder="Addiress Line 3" style = "display: none">
                                </ng-container>   
                            </ng-template>  
                            <ng-template #optionaladdress>                                
                                <mat-form-field [floatLabel]="'always'">
                                    <input matInput id = "addressLine1" class="addressLine1Validate" formControlName="out_address_1" (change)="omit_nonprintable_char($event)" placeholder="Address Line 1">
                                </mat-form-field>

                                <mat-form-field [floatLabel]="'always'">
                                    <input matInput id = "addressLine2" class="addressLine2Validate" formControlName="out_address_2" (change)="omit_nonprintable_char($event)" placeholder="Address Line 2">
                                </mat-form-field>

                                <mat-form-field [floatLabel]="'always'">
                                    <input matInput id = "addressLine3" class="addressLine3Validate" formControlName="out_address_3"  (change)="omit_nonprintable_char($event)" placeholder="Addiress Line 3">
                                </mat-form-field>                            
                            </ng-template>                     

                            <ng-container *ngIf="suburbBool;else noshowsuburb">
                                <mat-form-field [floatLabel]="'always'">
                                    <input matInput class="suburbValidate" #myAutocompleteTriggerSub="matAutocompleteTrigger" (input)="onInputSub($event)" [matAutocomplete]="autoSuburb" formControlName="out_suburb" placeholder="Suburb" (keydown.Tab)="chooseAutoCompletSuburb($event)" (keyup)="startFilterSub()"
                                        [required]="suburbBool">
                                    <mat-autocomplete #autoSuburb="matAutocomplete">
                                        <mat-option *ngFor="let option of filteredSubFromAPI" [value]="option?.suburb" (click)="chooseAutoComplete(option)">
                                            {{option?.suburb+", "+option?.state+", "+option?.postcode}}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </ng-container>
                            <ng-template #noshowsuburb>
                                <ng-container *ngIf="suburbN;else optionalsuburb">
                                    <input matInput class="suburbValidate" (input)="onInputSub($event)" formControlName="out_suburb" placeholder="Suburb" style="display:none">
                                </ng-container>
                            </ng-template>
                            <ng-template #optionalsuburb>                               
                                    <mat-form-field [floatLabel]="'always'">
                                        <input matInput class="suburbValidate" #myAutocompleteTriggerSub="matAutocompleteTrigger" (input)="onInputSub($event)" [matAutocomplete]="autoSuburb" formControlName="out_suburb" placeholder="Suburb" (keydown.Tab)="chooseAutoCompletSuburb($event)" (keyup)="startFilterSub()">
                                        <mat-autocomplete #autoSuburb="matAutocomplete">
                                            <mat-option *ngFor="let option of filteredSubFromAPI" [value]="option?.suburb" (click)="chooseAutoComplete(option)">
                                                {{option?.suburb+", "+option?.state+", "+option?.postcode}}
                                            </mat-option>
                                        </mat-autocomplete>
                                    </mat-form-field>                               
                            </ng-template>

                            <ng-container *ngIf="stateBool;else noshowstate">
                                <mat-form-field [floatLabel]="'always'">
                                    <mat-select class="stateValidate" bindValue="state" bindLabel="state" placeholder="{{statePlaceHolder}}" formControlName="out_state" [required]="stateBool">
                                        <mat-option *ngFor="let state of stateList" [value]="state">
                                            {{state}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </ng-container>
                            <ng-template #noshowstate>
                                <ng-container *ngIf="stateN;else optionalstate">
                                    <mat-form-field [floatLabel]="'always'" style="display:none">
                                        <mat-select class="stateValidate" bindValue="state" bindLabel="state" placeholder="{{statePlaceHolder}}" formControlName="out_state" style="display:none">
                                            <mat-option *ngFor="let state of stateList" [value]="state">
                                                {{state}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </ng-container>
                            </ng-template>
                            <ng-template #optionalstate>
                                <mat-form-field [floatLabel]="'always'">
                                    <mat-select class="stateValidate" bindValue="state" bindLabel="state" placeholder="{{statePlaceHolder}}" formControlName="out_state">
                                        <mat-option *ngFor="let state of stateList" [value]="state">
                                            {{state}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </ng-template>

                            <ng-container *ngIf="postcodeBool;else noshowpostcode">
                                <mat-form-field [floatLabel]="'always'">
                                    <input matInput class="postcodeValidate" maxlength="4" (input)="onInputPostcode($event)" #myAutocompleteTriggerPostcode="matAutocompleteTrigger" (keyup)="startFilterPostcode()" (keypress)="isNumberKey($event)" formControlName="out_postcode" (keydown.Tab)="chooseAutoCompletPostcode($event)"
                                        [matAutocomplete]="autoPostcode" placeholder="Post Code" [required]="postcodeBool">
                                    <mat-autocomplete #autoPostcode="matAutocomplete">
                                        <mat-option *ngFor="let option of filteredPostCodeFromAPI" [value]="option?.postcode" (click)="chooseAutoComplete(option)">
                                            {{option?.suburb+", "+option?.state+", "+option?.postcode}}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </ng-container>
                            <ng-template #noshowpostcode>
                                <ng-container *ngIf="postcodeN;else optionalpostcode">
                                    <input matInput class="postcodeValidate" maxlength="4" (input)="onInputPostcode($event)" formControlName="out_postcode" placeholder="Post Code" style="display:none">
                                </ng-container>
                            </ng-template>
                            <ng-template #optionalpostcode>
                                <mat-form-field [floatLabel]="'always'">
                                    <input matInput class="postcodeValidate" maxlength="4" (input)="onInputPostcode($event)" #myAutocompleteTriggerPostcode="matAutocompleteTrigger" (keyup)="startFilterPostcode()" (keypress)="isNumberKey($event)" formControlName="out_postcode" (keydown.Tab)="chooseAutoCompletPostcode($event)"
                                        [matAutocomplete]="autoPostcode" placeholder="Post Code">
                                    <mat-autocomplete #autoPostcode="matAutocomplete">
                                        <mat-option *ngFor="let option of filteredPostCodeFromAPI" [value]="option?.postcode" (click)="chooseAutoComplete(option)">
                                            {{option?.suburb+", "+option?.state+", "+option?.postcode}}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </ng-template>

                            <ng-container *ngIf="countryBool;else noshowcountry">
                                <mat-form-field [floatLabel]="'always'">
                                    <input matInput class="countryValidate" formControlName="out_country" placeholder="Country" [required]="countryBool">
                                </mat-form-field>
                            </ng-container>
                            <ng-template #noshowcountry>
                                    <ng-container *ngIf="countryN;else optionalcountry">
                                        <input matInput class="countryValidate" formControlName="out_country" placeholder="Country" style="display:none">
                                    </ng-container>
                            </ng-template>
                            <ng-template #optionalcountry>
                                <mat-form-field [floatLabel]="'always'">
                                    <input matInput class="countryValidate" formControlName="out_country" placeholder="Country">
                                </mat-form-field>
                            </ng-template>

                            <ng-container *ngIf="contactNameBool;else noshowcontactname">
                                <mat-form-field [floatLabel]="'always'">
                                    <input matInput class="contactValidate" formControlName="out_display_name" placeholder="Contact Name" [required]="contactNameBool">
                                </mat-form-field>
                            </ng-container>
                            <ng-template #noshowcontactname>
                                <ng-container *ngIf="contactNameN;else optionalcontactname">
                                    <input matInput class="contactValidate" formControlName="out_display_name" placeholder="Contact Name" style="display:none">
                                </ng-container>
                            </ng-template>
                            <ng-template #optionalcontactname>
                                <mat-form-field [floatLabel]="'always'">
                                    <input matInput class="contactValidate" formControlName="out_display_name" placeholder="Contact Name">
                                </mat-form-field>
                            </ng-template>

                            <ng-container *ngIf="phoneBool;else noshowphoneno">
                                <mat-form-field [floatLabel]="'always'">
                                    <input matInput class="phoneValidate" formControlName="out_phone" (keypress)="isNumberKey($event)" placeholder="Phone" [required]="phoneBool">
                                </mat-form-field>
                            </ng-container>         
                            <ng-template #noshowphoneno>
                                <ng-container *ngIf="phoneN;else optionalphoneno">
                                    <input matInput class="phoneValidate" formControlName="out_phone" (keypress)="isNumberKey($event)" placeholder="Phone" style="display:none">
                                </ng-container>
                            </ng-template>  
                            <ng-template #optionalphoneno>
                                <mat-form-field [floatLabel]="'always'">
                                    <input matInput class="phoneValidate" formControlName="out_phone" (keypress)="isNumberKey($event)" placeholder="Phone">
                                </mat-form-field>
                            </ng-template>                  

                            <ng-container *ngIf="emailBool;else noshowemail">
                                <mat-form-field [floatLabel]="'always'">
                                    <input matInput class="emailValidate" formControlName="out_email" placeholder="Email" [required]="emailBool">
                                </mat-form-field>
                            </ng-container>
                            <ng-template #noshowemail>
                                <ng-container *ngIf="emailN;else optionalemail">                                    
                                    <input matInput class="emailValidate" formControlName="out_email" placeholder="Email" style = "display: none">
                                </ng-container>                                                         
                            </ng-template>
                            <ng-template #optionalemail>                               
                                <mat-form-field [floatLabel]="'always'">
                                    <input matInput class="emailValidate" formControlName="out_email" placeholder="Email">
                                </mat-form-field>                           
                            </ng-template>

                        </div>
                    </div>
                </div>
                <div class="button-center">
                    <button class="button button-red button-large endusernext" (click)="nextPage()">Next</button>
                </div>
                <div id="bottom-navigation">
                    <button class="btnLink" [routerLink]="['../ship-address']" (click)="goPrevious()" *ngIf="checkoutViewModel?.firstStep != 'ENDUSER'">Previous</button>
                    <span *ngIf="checkoutViewModel?.firstStep != 'ENDUSER'">&nbsp;|&nbsp;</span>

<!--                    <ng-container *ngIf="serial;else goRenewals">-->
<!--                        <button class="btnLink" (click)="backtoRenewals()">Back to renewals</button>-->
<!--                    </ng-container>-->
<!--                    <ng-template #goRenewals>-->
<!--                        <button class="btnLink" (click)="backtoCart()">Back to cart</button>-->
<!--                    </ng-template>-->

                  <ng-container [ngSwitch]="backto">
                    <button *ngSwitchCase="'renewal'" (click)="backtoRenewals()">Back to renewals
                    </button>
                    <button *ngSwitchCase="'quote'"  (click)="backtoQuotes()">Back to quotes
                    </button>
                    <button *ngSwitchDefault  (click)="backtoCart()">Back to cart</button>
                  </ng-container>
                </div>
            </div>
        </div>
        <loading-screen *ngIf="!loadContent" backDropWidth='350' [showInnerLoading]="true"></loading-screen>
    </div>

</div>
<router-outlet></router-outlet>
<div class="subBlockContainer subBlockContainer-flex" *ngIf="salesTypeDescriptionFilter?.length">
    <ng-container *ngFor="let salesTypeDesc of salesTypeDescriptionFilter; let idx = index">
        <div class="subBlockContent subBlockContent-display" id="{{salesTypeArrayFilter[idx]}}_content">
            <child-header [title]="salesTypeDesc" (closeEvent)="closeSalesType(salesTypeArrayFilter[idx],idx)"></child-header>
            <div class="child-body">
                <div class="inner-subBlock-wrapper">
                    <!-- <div class="page-title-wrapper">
            <div class="title blade-title-font">
              {{salesTypeDesc}}
            </div>
            <i class="material-icons closebutton-pullfloat-right"
              (click)="closeSalesType(salesTypeArrayFilter[idx],idx)">close</i>
          </div> -->
                    <form id="{{salesTypeArrayFilter[idx]}}">
                        <div [innerHTML]="templateArray[idx] | sanitizeHtml"></div>
                    </form>
                    <div class="button-center">
                        <button class="button button-red button-large btn{{salesTypeArrayFilter[idx]}}" (click)="nextSalesType(salesTypeArrayFilter[idx])">Next</button>
                    </div>
                    <div id="bottom-navigation">
                        <!-- <button class="btnLink">Previous</button>
            <span>&nbsp;|&nbsp;</span> -->
                        <!-- <button class="btnLink" (click)="close()">Back to cart</button> -->
                        <ng-container *ngIf="serial;else goRenewals">
                            <button class="btnLink" (click)="backtoRenewals()">Back to renewals</button>
                        </ng-container>
                        <ng-template #goRenewals>
                            <button class="btnLink" (click)="backtoCart()">Back to cart</button>
                        </ng-template>
                    </div>
                </div>
            </div>
            <loading-screen *ngIf="!loadContent" backDropWidth='350' [showInnerLoading]="false"></loading-screen>
        </div>
    </ng-container>
</div>
